import rozcestnikDalsi from "../../content/rozcestnik/rozcestnikDalsi";
import rozcestnikDalsi2 from "../../content/rozcestnik/rozcestnikDalsi2";
import { renderLoginComponent } from "../../components/Login";
import { initRozcestnikZapisy } from "./rozcestnikZapisyService";
import { initRozcestnik, callToast } from "./rozcestnikService";
import { destroyElement } from "../../utils/common.mjs";

export function initRozcestnikDalsi(isPublic) {

    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikDalsi(isPublic));
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    let rozcestnikDalsi2Tile = document.getElementById('rozcestnikDalsi2Tile');
    rozcestnikDalsi2Tile?.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikDalsi2(isPublic);
        
    });

    let rozcestnikDalsiS8409 = document.getElementById('rozcestnikDalsiS8409');

    if (isPublic) {
        rozcestnikDalsiS8409?.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S8409');
            
        });
    } else {
        rozcestnikDalsiS8409?.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S8409', null, null);
            
        });
    }
    document.getElementById('toastNavrhNaOpravu')?.addEventListener("click", event => {
        event.preventDefault();
        callToast("Návrh na opravu chybného údaje katastru nemovitostí");
    });

    document.getElementById('toastDalsiZememerictvi')?.addEventListener("click", event => {
        event.preventDefault();
        callToast("Zeměměřictví");
    });

    initRozcestnikBreadcrumbs(isPublic);
}

function initRozcestnikDalsi2(isPublic) {

    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikDalsi2());
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const toastZamerZnacka = document.getElementById('toastZamerZnacka');
    toastZamerZnacka?.addEventListener("click", event => {
        event.preventDefault();
        callToast("Záměr o umístění značky");
    });

    let rozcestnikDalsi2S8008 = document.getElementById('rozcestnikDalsi2S8008');
    
    if (isPublic) {
      rozcestnikDalsi2S8008?.addEventListener("click", (event) => {
        event.preventDefault();
        renderLoginComponent("S8008");
      });
    } else {
      rozcestnikDalsi2S8008?.addEventListener("click", (event) => {
        event.preventDefault();
        window.initFormio("S8008", null, null);
      });
    }
    
    
    initRozcestnikBreadcrumbs(isPublic);
}

function initRozcestnikBreadcrumbs(isPublic) {

    const home = document.getElementById('rozcestnikRoot');
    home.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnik(isPublic);
    });

    const rozcestnikZapisy = document.getElementById('rozcestnikZapisy');    
    if (rozcestnikZapisy) {
        rozcestnikZapisy.addEventListener("click", event => {
            event.preventDefault();
            initRozcestnikZapisy(isPublic);
        })
    }
    
    const rozcestnikDalsi = document.getElementById('rozcestnikDalsi');
    if (rozcestnikDalsi) {
        rozcestnikDalsi.addEventListener("click", event => {
            event.preventDefault();
            initRozcestnikDalsi(isPublic);
        })
    }
}
